import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dayjs from 'dayjs';

const S = {
  Wrapper: styled.p`
    color: ${({ theme }) => theme.palette.grey[800]};
    font-size: 0.75rem;
  `,
  Em: styled.em`
    margin-right: 4px;
    font-style: normal;
  `,
};

const ResponseDate = ({ updatedAt }) => (
  <S.Wrapper>
    <S.Em>응답시간</S.Em>
    <time dateTime={dayjs(updatedAt).format('YYYY.MM.DD. HH:mm')}>
      {dayjs(updatedAt).format('YYYY.MM.DD. HH:mm')}
    </time>
  </S.Wrapper>
);

ResponseDate.propTypes = {
  updatedAt: PropTypes.number,
};

ResponseDate.defaultProps = {
  updatedAt: 0,
};

export default ResponseDate;
